import { API_URL } from './env'

export interface Sound {
  id: string
  code: string

  el?: HTMLElement
}

export interface SoundSaveRequest {
  code: string
}

export interface SoundSaveResponse {
  id: string
}

async function apiCall<T extends object, R>(method: 'GET' | 'POST', path: string, data?: T): Promise<R> {
  if (!path.startsWith('/')) path = `/${path}`
  const url = `${API_URL}${path}`
  const body = data ? JSON.stringify(data) : null
  const res = await fetch(url, {
    method,
    body
  })
  if (!res.ok) {
    throw new Error(`${res.status} ${await res.text()}`)
  }
  return await res.json() as R
}

export async function saveSound(code: string) {
  const req: SoundSaveRequest = { code }
  const res: SoundSaveResponse = await apiCall('POST', 'save', req)
  const sound: Sound = {
    id: res.id,
    code
  }
  return sound
}

export async function listSounds() {
  const sounds: Sound[] = await apiCall('GET', 'list')
  return sounds
}
